module.exports = __webpack_public_path__ + "img/xCircle.ac31904c.svg";